var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { MenuItem } from '@mui/material';
import { Select, useSimpleModal } from 'hx-ui';
import { createNumberArray, validateAge } from 'hx-util';
var DEFAULT_MIN_AGE = 18;
export var AgeSelect = function (_a) {
    var _b = _a.minAge, minAge = _b === void 0 ? DEFAULT_MIN_AGE : _b, _c = _a.modal, _d = _c === void 0 ? {} : _c, _e = _d.message, modalMessage = _e === void 0 ? "This hearing screener is only designed for users over the age of ".concat(minAge, ".") : _e, modalConfig = _d.config, _f = _a.selectProps, _g = _f === void 0 ? {} : _f, _h = _g.name, name = _h === void 0 ? 'birth-year' : _h, _j = _g.label, label = _j === void 0 ? 'Select your birth year' : _j, _k = _g.className, className = _k === void 0 ? 'min-w-[15em]' : _k, _l = _g.variant, variant = _l === void 0 ? 'standard' : _l, _m = _g.rules, rules = _m === void 0 ? {
        required: 'Please select your birth year',
        validate: function (value) {
            return validateAge(Number(value), DEFAULT_MIN_AGE)
                ? undefined
                : "You must be at least ".concat(DEFAULT_MIN_AGE, " years old");
        },
    } : _m;
    var _o = useSimpleModal(modalMessage, modalConfig), modal = _o[0], toggleModal = _o[1];
    var handleChange = function (event) {
        var selectedBirthYear = Number(event.target.value);
        var currentYear = new Date().getFullYear();
        var age = currentYear - selectedBirthYear;
        if (age < minAge)
            toggleModal();
    };
    return (_jsxs(_Fragment, { children: [_jsx(Select, __assign({}, { name: name, label: label, className: className, variant: variant, rules: rules }, { watcher: handleChange }, { children: createNumberArray(new Date().getFullYear(), 1900).map(function (year) { return (_jsx(MenuItem, __assign({ value: year }, { children: year }), "age-select-option-".concat(year))); }) })), modal] }));
};
